import type { AvailableLanguagesType } from '@carrefour-gcs/shared';

import { useTrpc } from '#composables/useTrpc';

export async function getDocumentationURL(lang: AvailableLanguagesType, isProductTour: boolean) {
  return useTrpc().core.documentation.getDocumentationURL.query({ lang, isProductTour });
}
